// extracted by css-extract-rspack-plugin
export default {"moduleFilter":"moduleFilter-ytta9e"};